import { db } from '../../firebase';

export const startSendInvoice = (payload) => {
  // const message = {
  //   invoiceID: payload.invoiceID,
  //   grandTotal: payload.grandTotal,
  //   balance: payload.balance,
  //   recipient: payload.recipient
  // };
  // const message = {
  //   original: "test"
  // }

  return (dispatch) => db.sendInvoice(payload)
};



// WEBPACK FOOTER //
// ./src/store/actions/invoicePreview.jsx